// import React, {useState, useEffect} from 'react'
import "./aboutpage.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight, faHeart } from '@fortawesome/free-solid-svg-icons';
import CountUp from "react-countup";
// import AboutSlider from './AboutSlider';
// import Team from "../HomePage/Team/Team"
import AboutSection from "./AboutSection";
import { countdata } from "../../constants/AboutConstants";
import AboutUsFeatures from "./AboutUsFeatures";
import ImageSlider from "./ImageSlider";

const AboutPage = () => {
  const bg1 = "../images/bg/bg1.webp";

  return (
    <>
      <AboutSection data="ABOUT US" backgroundImage={bg1} />
      <AboutUsFeatures />

      <div className="lg:py-[105px] md:py-[60px] py-[10px] relative flex lg:flex-row max-sm:flex-col px-[15px] bg-[#000000]">
        {countdata.map((data, index) => (
          <div
            key={index}
            className="text-center lg:w-[33.3%] w-full relative min-h-[1px] px-[15px]"
          >
            <h3
              id="social-rating"
              className="tracking-[2px] text-[24px] leading-[30px] font-normal text-secondary1 mb-[23px] pb-[30px] uppercase relative"
            >
              {data.title}{" "}
            </h3>
            <span className="md:text-[50px] text-[20px] leading-[70px] text-secondary1 uppercase tracking-[2px] block max-sm:mb-[30px]">
              <CountUp
                start={0}
                end={data.num}
                delay={0}
                duration={1}
                decimals={data.decimal}
                enableScrollSpy
                scrollSpyDelay={0}
              />
              +
            </span>
          </div>
        ))}
      </div>

      <ImageSlider />
    </>
  );
};

export default AboutPage;
